module.exports = __webpack_public_path__ + "assets/1792649897182/img/logo.a000904b.png";